import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, Typography, type TypographyProps } from '@mui/material';
import { type CtaAnalyticsProps, CtaLink } from '../../CTA/CtaLink';
import { Rating } from '../Rating';
import { StarRatingTooltip } from '../StarRatingTooltip';
export type RatingReviewsProps = {
  ctaAnalytics: CtaAnalyticsProps;
  starRating: number;
  reviewLink: string | null;
  starRatingTooltip?: string;
  containerProps?: Partial<BoxProps> & {
    'data-testid'?: string;
  };
  textContainerProps?: Partial<BoxProps>;
  textProps?: Partial<TypographyProps>;
  isMonetizing?: boolean;
  segmentActionSection?: 'marketplace_comparison_table_product' | 'alt_pick';
};
export function RatingReviews(t0) {
  const $ = _c(21);
  const {
    ctaAnalytics,
    reviewLink,
    starRating,
    starRatingTooltip,
    containerProps,
    textContainerProps,
    isMonetizing: t1,
    textProps,
    segmentActionSection: t2
  } = t0;
  const isMonetizing = t1 === undefined ? true : t1;
  const segmentActionSection = t2 === undefined ? "marketplace_comparison_table_product" : t2;
  let t3;
  if ($[0] !== textProps) {
    t3 = <Typography variant="text" {...textProps}>NerdWallet rating</Typography>;
    $[0] = textProps;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const ratingText = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      marginTop: "10px",
      marginRight: "5px",
      marginBottom: "3px"
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== starRating) {
    t5 = <Rating value={starRating} size="19px" gap="5px" additionalStyles={t4} />;
    $[3] = starRating;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== ctaAnalytics || $[6] !== ratingText || $[7] !== reviewLink) {
    t6 = reviewLink ? <CtaLink target="_blank" href={reviewLink} analytics={ctaAnalytics} parameterActions={[]} sx={{
      paddingRight: 0.5
    }} skipShoppingFinishedEvent={true} isReview={true}>{ratingText}</CtaLink> : ratingText;
    $[5] = ctaAnalytics;
    $[6] = ratingText;
    $[7] = reviewLink;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isMonetizing || $[10] !== segmentActionSection || $[11] !== starRatingTooltip) {
    t7 = starRatingTooltip && <StarRatingTooltip isMonetizing={isMonetizing} segmentActionSection={segmentActionSection} />;
    $[9] = isMonetizing;
    $[10] = segmentActionSection;
    $[11] = starRatingTooltip;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== textContainerProps) {
    t8 = <Box display="flex" alignItems="center" {...textContainerProps}>{t6}{t7}</Box>;
    $[13] = t6;
    $[14] = t7;
    $[15] = textContainerProps;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== containerProps || $[18] !== t5 || $[19] !== t8) {
    t9 = <Box data-testid="comparison-table-rating" {...containerProps}>{t5}{t8}</Box>;
    $[17] = containerProps;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}